import evaluate from './evaluate'
import confirmYuesao from './confirmYuesao'
// import product from './product'
import promotionInfo from './promotionInfo'
import insurance from './insurance'

export default {
  evaluate,
  confirmYuesao,
  // product,
  promotionInfo,
  insurance
}
